import { CenterProvider } from "./center";

export default CenterProvider;
